import type { ColDef } from "ag-grid-community";

export const defaultColDef: ColDef<unknown, unknown> = {
  editable: false,
  resizable: true,
  filter: true,
  lockVisible: true,
  suppressMovable: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
  flex: 1,
};
